import { useMutation } from '@tanstack/react-query'
import { PostsService } from 'src/services/posts'

export type UsePostUnpinPostProps = {
  communityId: number
  postId: number
}

const usePostUnpinPost = () =>
  useMutation(({ communityId, postId }: UsePostUnpinPostProps) =>
    PostsService.postUnpinPost({ communityId, postId })
  )

export default usePostUnpinPost
